import { TERMS_OF_SERVICE_REQUIRED_DATE } from 'constants/terms-of-service';
import { User } from 'sync/user-service';
import dayjs from 'utils/dayjs';

export const accountCreatedOnOrAfterTermsOfServiceRequiredDate = (date: string) => {
  const accountCreationDate = dayjs(date);

  // if the account was created after or on the same day of the terms of service required date
  // return true, which indicates that we need to check the users terms of service.
  if (accountCreationDate.isAfter(TERMS_OF_SERVICE_REQUIRED_DATE) || accountCreationDate.isSame(TERMS_OF_SERVICE_REQUIRED_DATE)) {
    return true;
  }

  return false;
};

/**
 * Checks that the user passed in has accepted TOS
 * @param user - Current session user
 * @returns
 */
export const hasAcceptedTos = (user: User) => {
  // check that terms of service is defined.
  if (user.preferences === undefined || user.preferences.termsOfService === undefined) {
    return false;
  }

  // check that Tos value are of the correct type and have values.
  const acceptedAtValid =
    typeof user.preferences.termsOfService.acceptedAt === 'string' && user.preferences.termsOfService.acceptedAt.length > 0;
  const versionValid = typeof user.preferences.termsOfService.version === 'string' && user.preferences.termsOfService.version.length > 0;

  return acceptedAtValid && versionValid;
};

/**
 * requiresTosAcceptance checks whether or not the passed in user needs further tos checks.
 * SSO users have their own Tos paths, so this checks that the passed in user is not an sso user.
 * @param user - Current session user
 * @returns a boolean indicating whether or not the user must accept ToS
 */
export const requiresTosAcceptance = (user: User) => {
  // user is an sso user
  if (user.sso !== undefined) {
    return false;
  }

  // if the account was created on or after the terms of service required at date
  if (accountCreatedOnOrAfterTermsOfServiceRequiredDate(user.audit.createdAt)) {
    return true;
  }

  // account created before required date
  return false;
};

/**
 * afterTosDate checks whether or not the passed in user needs further tos checks.
 * @param user - Current session user
 * @returns a boolean indicating whether or not the user must accept ToS
 */
export const afterTosDate = (user?: User) => {
  return user && accountCreatedOnOrAfterTermsOfServiceRequiredDate(user.audit.createdAt);
};
